import { StudentSubjectMenuList } from '@models/interfaces/parent.interface';
import AUTH_API from '@services/auth.service';

const ParentService = {
  async student_subject_menu_list() {
    return AUTH_API.post<{
      error: boolean;
      error_code: string;
      error_msg: string;
      data: StudentSubjectMenuList[];
    }>(`/parents/student_subject_menu_list/json`).then(res => {
      if (res.data.error) throw res.data.error_msg;
      return res.data.data;
    });
  },
};

export default ParentService;
